import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllMakes = createAsyncThunk(
    'make/getAllMakes',
    async ({ skip, limit, search, status }, { rejectWithValue }) => {
        try {
            const params = {};
            if (skip !== undefined) params.skip = skip;
            if (limit !== undefined) params.limit = limit;
            if (search) params.search = search;
            if (status) params.status = status;

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/make`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const addNewMake = createAsyncThunk(
    'make/addNewMake',
    async (makeData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                withCredentials: true,
            };

            const formData = new FormData();

            formData.append("name", makeData.name);
            formData.append("image", makeData.file);

            const response = await axios.post(`${PUBLIC_BASE_URL}/make/create-make`, formData, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const editMake = createAsyncThunk(
    'make/editMake',
    async (updatedData, { rejectWithValue }) => {
        try {

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(updatedData);

            const response = await axios.put(`${PUBLIC_BASE_URL}/make/update-make-info`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const editMakeImage = createAsyncThunk(
    'make/editMakeImage',
    async (data, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',

                },
                withCredentials: true,
            };

            const formData = new FormData();
            if (data.file) formData.append('image', data.file);
            if (data.id) formData.append('makeId', data.id);

            const response = await axios.put(
                `${PUBLIC_BASE_URL}/make/update-image`,
                formData,
                config
            );

            return response.data;

        } catch (err) {
            if (err.message === 'Network Error') {
                return rejectWithValue({
                    message: 'Network Error',
                    status: 404,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred');
            }
        }
    }
);